<template>
    <div>
        <div class="content-heading">
            <i class="ic-head-icon">
                <img src="@/assets/images/settings.svg" alt="">
            </i>
            <h4 class="head-title">Account Settings</h4>
            <i class="ic-tooltip" id="help"></i>
            <b-popover 
                target="help"
                triggers="hover"
                content="This section allows you to update your general account information including the terms of use of your loyalty program."
            >
            </b-popover>
            <div class="head-tabs">
                <b-nav tabs>
                    <b-nav-item :to="{ path: '/account/profile'}">
                        My Profile
                    </b-nav-item>
                    <template v-if="!restrictMarketplace()">
                        <b-nav-item :to="{ path: '/account/terms' }" v-if="permission.hasAccess('account-settings.terms')">
                            Terms
                        </b-nav-item>
                    </template>
                    <b-nav-item :to="{ path: '/account/users' }" v-if="permission.hasAccess('account-settings.users')">
                        Users
                    </b-nav-item>
                    <b-nav-item :to="{ path: '/account/security' }" v-if="permission.hasAccess('account-settings.security')">
                        Security
                    </b-nav-item>
                    <template v-if="!restrictMarketplace()">
                        <b-nav-item :to="{ path: '/account/extensions' }" v-if="permission.hasAccess('account-settings.extensions')">
                            Extensions
                        </b-nav-item>
                    </template>
                    <template>
                        <b-nav-item :to="{ path: '/account/documents' }" v-if="permission.hasAccess('account-settings.documents')">
                            Documents
                        </b-nav-item>
                    </template> 
                </b-nav>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import permission from "../../services/user.permission";
import { mapState } from "vuex";

export default {
    name: "mechanics",
    data() {
        return {
            msg: "Mechanics",
            permission: permission,
            env: process.env.VUE_APP_MODE
        };
    },
    computed: {
        ...mapState("auth", ["planId"])
    },
    methods: {
        hasAccess(module) {
            return permission.hasAccess(module);
        },
        restrictMarketplace() {
            if (this.planId == 5) return true;

            return false;
        }
    }
};
</script>

<style scoped>
</style>
